export const PowerBtn = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="power-off"
      className="prefix__svg-inline--fa prefix__fa-power-off prefix__fa-w-16"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      {...props}
    >
      <path
        fill={props.fill}
        d="M400 54.1c63 45 104 118.6 104 201.9 0 136.8-110.8 247.7-247.5 248C120 504.3 8.2 393 8 256.4 7.9 173.1 48.9 99.3 111.8 54.2c11.7-8.3 28-4.8 35 7.7L162.6 90c5.9 10.5 3.1 23.8-6.6 31-41.5 30.8-68 79.6-68 134.9-.1 92.3 74.5 168.1 168 168.1 91.6 0 168.6-74.2 168-169.1-.3-51.8-24.7-101.8-68.1-134-9.7-7.2-12.4-20.5-6.5-30.9l15.8-28.1c7-12.4 23.2-16.1 34.8-7.8zM296 264V24c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24v240c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24z"
      />
    </svg>
  )
}

export const Github = (props) => {
    return (
        <svg
          aria-hidden="true"
          data-prefix="fab"
          data-icon="github"
          className="prefix__svg-inline--fa prefix__fa-github prefix__fa-w-16"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 496 512"
          {...props}
        >
          <path
            fill={props.fill}
            d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
          />
        </svg>
      )
}

export const Twitter = (props) => {
    return (
        <svg
          aria-hidden="true"
          data-prefix="fab"
          data-icon="twitter"
          className="prefix__svg-inline--fa prefix__fa-twitter prefix__fa-w-16"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          {...props}
        >
          <path
            fill={props.fill}
            d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
          />
        </svg>
      )
}

export const Facebook = (props) => {
    return (
        <svg
          aria-hidden="true"
          data-prefix="fab"
          data-icon="facebook"
          className="prefix__svg-inline--fa prefix__fa-facebook prefix__fa-w-16"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          {...props}
        >
          <path
            fill={props.fill}
            d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"
          />
        </svg>
      )
}

export const YouTube = (props) => {
    return (
        <svg
          aria-hidden="true"
          data-prefix="fab"
          data-icon="youtube"
          className="prefix__svg-inline--fa prefix__fa-youtube prefix__fa-w-18"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 19 19"
          {...props}
        >
          <path
            fill={props.fill}
            d="M21,3H3v18h18V3z M9,17H6.477v-7H9V17z M7.694,8.717c-0.771,0-1.286-0.514-1.286-1.2s0.514-1.2,1.371-1.2 c0.771,0,1.286,0.514,1.286,1.2S8.551,8.717,7.694,8.717z M18,17h-2.442v-3.826c0-1.058-0.651-1.302-0.895-1.302 s-1.058,0.163-1.058,1.302c0,0.163,0,3.826,0,3.826h-2.523v-7h2.523v0.977C13.93,10.407,14.581,10,15.802,10 C17.023,10,18,10.977,18,13.174V17z"
          />
        </svg>
      )
}

export const YinYang = (props) => {
    return (
        <svg
          aria-hidden="true"
          data-prefix="fas"
          data-icon="yin-yang"
          className="prefix__svg-inline--fa prefix__fa-yin-yang prefix__fa-w-16"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 496 512"
          {...props}
        >
          <path
            fill={props.fill}
            d="M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 376c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-128c-53.02 0-96 42.98-96 96s42.98 96 96 96c-106.04 0-192-85.96-192-192S141.96 64 248 64c53.02 0 96 42.98 96 96s-42.98 96-96 96zm0-128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
          />
        </svg>
      )
}

export const Anchor = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="anchor"
      className="prefix__svg-inline--fa prefix__fa-anchor prefix__fa-w-18"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 576 512"
      {...props}
    >
      <path
        fill={props.fill}
        d="M12.971 352h32.394C67.172 454.735 181.944 512 288 512c106.229 0 220.853-57.38 242.635-160h32.394c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0l-67.029 67.029c-7.56 7.56-2.206 20.485 8.485 20.485h35.146c-20.29 54.317-84.963 86.588-144.117 94.015V256h52c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-52v-5.47c37.281-13.178 63.995-48.725 64-90.518C384.005 43.772 341.605.738 289.37.01 235.723-.739 192 42.525 192 96c0 41.798 26.716 77.35 64 90.53V192h-52c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v190.015c-58.936-7.399-123.82-39.679-144.117-94.015h35.146c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0L4.485 331.515C-3.074 339.074 2.28 352 12.971 352zM288 64c17.645 0 32 14.355 32 32s-14.355 32-32 32-32-14.355-32-32 14.355-32 32-32z"
      />
    </svg>
  )
}



export const Link = (props) => {
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="link"
      className="prefix__svg-inline--fa prefix__fa-link prefix__fa-w-16"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      {...props}
      
    >
      <path
        fill={props.fill}
        
        d="M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 01-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0120.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0020.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 00-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"
      />
    </svg>
  )
}



export const Design = (props) => { 
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="palette"
      className="prefix__svg-inline--fa prefix__fa-palette prefix__fa-w-16"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      {...props}
    >
      <path
        fill={props.fill}
        d="m478.696 217.06h-33.873c-3.423-12.84-8.521-25.116-15.209-36.629l23.933-23.887c2.723-2.718 4.222-6.334 4.222-10.181 0-3.848-1.5-7.464-4.223-10.181l-34.8-34.734c-5.604-5.593-14.721-5.595-20.325 0l-23.966 23.92c-11.54-6.682-23.848-11.774-36.717-15.191v-33.781c0-7.932-6.454-14.385-14.386-14.385h-20.942v-25.121c0-20.341-16.549-36.89-36.89-36.89h-209.71c-20.341 0-36.89 16.549-36.89 36.89v49.229c0 4.144 3.359 7.503 7.503 7.503s7.503-3.359 7.503-7.503v-49.229c0-12.067 9.818-21.884 21.884-21.884h209.71c12.066 0 21.884 9.817 21.884 21.884v379.628h-253.478v-295.897c0-4.144-3.359-7.503-7.503-7.503s-7.503 3.359-7.503 7.503v354.489c0 20.341 16.549 36.89 36.89 36.89h209.71c20.341 0 36.89-16.549 36.89-36.89v-25.12h20.942c7.932 0 14.386-6.453 14.386-14.385v-33.781c12.87-3.417 25.177-8.509 36.717-15.191l23.966 23.92c5.604 5.592 14.722 5.593 20.324 0l34.802-34.734c2.723-2.718 4.222-6.334 4.222-10.181 0-3.848-1.5-7.464-4.223-10.181l-23.932-23.887c6.688-11.512 11.786-23.788 15.209-36.628h33.873c7.932 0 14.385-6.453 14.385-14.385v-49.109c0-7.934-6.453-14.388-14.385-14.388zm-191.292 258.05c0 12.067-9.818 21.884-21.884 21.884h-209.71c-12.067 0-21.884-9.817-21.884-21.884v-43.586h253.478zm190.67-195.176h-39.136c-3.511 0-6.553 2.436-7.321 5.862-3.417 15.242-9.408 29.673-17.81 42.891-1.887 2.969-1.459 6.85 1.032 9.335l27.666 27.614-33.921 33.857-27.687-27.633c-2.481-2.478-6.347-2.905-9.314-1.029-13.248 8.389-27.708 14.371-42.981 17.78-3.43.765-5.869 3.809-5.869 7.323v39.049h-20.323v-85.751c20.832-.819 40.875-8.576 56.795-22.068 3.162-2.679 3.552-7.414.874-10.575-2.679-3.161-7.414-3.552-10.575-.873-13.213 11.198-29.813 17.693-47.094 18.502v-156.433c41.57 1.921 74.799 36.264 74.799 78.215 0 12.443-2.835 24.335-8.428 35.346-1.876 3.695-.402 8.211 3.292 10.087 3.697 1.877 8.21.402 10.088-3.292 6.671-13.137 10.054-27.315 10.054-42.141 0-50.226-39.958-91.303-89.805-93.236v-85.748h20.322v39.049c0 3.514 2.438 6.557 5.869 7.323 15.273 3.41 29.734 9.392 42.981 17.78 2.965 1.877 6.833 1.449 9.314-1.029l27.687-27.633 33.921 33.857-27.666 27.614c-2.49 2.485-2.919 6.366-1.033 9.335 8.403 13.219 14.395 27.65 17.811 42.892.768 3.427 3.81 5.862 7.321 5.862h39.136v47.868z"/>
    </svg>
  )

}

export const Develope = (props) => { 
  return (
    <svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="laptop-code"
      className="prefix__svg-inline--fa prefix__fa-laptop-code prefix__fa-w-20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 512"
      {...props}
    >
      <path
         fill={props.fill}
        d="m484.307 403.646-53.585-53.584h9.521c12.958 0 23.5-10.542 23.5-23.5s-10.542-23.5-23.5-23.5h-7.349v-4.301c0-4.143-3.357-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v4.301h-43.876c-6.214-.057-12.392 2.61-16.936 7.23-4.355 4.428-6.695 10.227-6.594 16.339v8.379h-21.638c-4.143 0-7.5 3.357-7.5 7.5 0 .263.014.524.041.78-.026.256-.041.516-.041.78v127.06c0 14.265-11.605 25.87-25.87 25.87h-233.8c-14.265 0-25.87-11.605-25.87-25.87v-430.26c0-14.265 11.605-25.87 25.87-25.87h29.2l3.385 17.671c3.172 16.554 17.704 28.569 34.556 28.569h99.521c16.852 0 31.384-12.016 34.556-28.57l3.382-17.67h29.2c14.265 0 25.87 11.605 25.87 25.87v153.345c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-153.345c0-22.536-18.334-40.87-40.87-40.87h-233.8c-22.536 0-40.87 18.334-40.87 40.87v430.26c0 22.536 18.334 40.87 40.87 40.87h233.8c22.536 0 40.87-18.334 40.87-40.87v-121.12h14.138v42.806c0 12.958 10.542 23.5 23.5 23.5s23.5-10.542 23.5-23.5v-9.521l53.584 53.585c.027.026.055.054.082.08 4.299 4.17 10.415 6.735 16.759 6.735 5.626 0 11.43-2.019 16.302-6.726.03-.03.062-.06.092-.09 4.438-4.438 6.883-10.34 6.883-16.617s-2.446-12.178-6.883-16.616zm-233.299-388.646-2.844 14.849c-1.819 9.498-10.156 16.392-19.823 16.392h-99.521c-9.667 0-18.004-6.894-19.823-16.392l-2.844-14.849zm222.736 411.228c-4.146 3.956-9.654 2.35-12.112-.003l-66.34-66.34c-2.146-2.146-5.372-2.788-8.174-1.625-2.803 1.16-4.63 3.896-4.63 6.929v27.627c0 4.687-3.813 8.5-8.5 8.5s-8.5-3.813-8.5-8.5v-66.254c0-.051-.001-.102-.002-.152-.054-2.649 1.215-4.507 2.289-5.599 1.67-1.697 4.027-2.749 6.188-2.749h.025 66.254c4.687 0 8.5 3.813 8.5 8.5s-3.813 8.5-8.5 8.5h-27.627c-3.033 0-5.769 1.827-6.929 4.63-1.161 2.803-.52 6.028 1.625 8.174l66.388 66.388c1.605 1.604 2.49 3.739 2.49 6.01 0 2.248-.868 4.364-2.445 5.964z"/>
    </svg>
  )

}